module.exports = __webpack_public_path__ + "img/audio-portrait_jp.d3babba.jpg";